import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/common/actionCardTimerTime.svg?url_encode")